import { __assign } from "tslib";
import React from 'react';
import ImageThumbHtmlView from './ImageHtml';
import MinimalDumbo from '../../../../DeviationViews/Dumbo/EditorDumbo';
var ImageThumbView = function (props) {
    if (props.isHtml) {
        return React.createElement(ImageThumbHtmlView, __assign({}, props));
    }
    /* In editor we make the background transparent to avoid overlapping with custom backgrounds */
    return React.createElement(MinimalDumbo, __assign({ useBackgroundColor: false }, props));
};
ImageThumbView.displayName = 'ImageThumbView';
export default ImageThumbView;
//# sourceMappingURL=index.js.map